import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Button } from '../../components/ui/button'
import ScrollToTopOnMount from '../../components/Effects/ScrollToTopOnMount'

type IProps = RouteComponentProps<any>

const NotFound = (props: IProps) => {
  const onBackPress = () => {
    props.history.goBack()
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2 py-24 text-center">
      <ScrollToTopOnMount />
      <h1 className="text-base font-medium">{'Whoops!'}</h1>
      <p className="text-sm text-muted-foreground">
        {'We are unable to find the page you are looking for'}
      </p>
      <Button className="mt-2" onClick={onBackPress}>
        {'Back'}
      </Button>
    </div>
  )
}

export default NotFound
